import type { GetServerSideProps } from 'next';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ContentLayout from '@/components/shared/layouts/ContentLayout';
import MainLayout from '@/components/shared/layouts/MainLayout/main';
import PageLoader from '@/components/shared/utillities/loaders/PageLoader';
import { ApplicationsStoreContextProvider } from '@/context/applications';
import { ApplicationsStore } from '@/domain/applications';
import { ApplicationsLayout } from '@/features/applications';
import { useRouter } from 'next/router';

type FormPageProps = {
	selectionId?: number;
};

const FormTemplatePage = ({ selectionId }: FormPageProps) => {
	const router = useRouter();
	const [requestStatus, setRequestStatus] = useState<'loading' | 'error' | 'success'>('loading');

	const Store = useMemo(() => new ApplicationsStore(true), []);

	const { t } = useTranslation();

	useEffect(() => {
		const init = async () => {
			try {
				await Store.initializePageData(selectionId);

				setRequestStatus('success');
			} catch (e) {
				router.push('/').catch(console.error);
			}
		};

		init().catch(console.error);
	}, []);

	if (requestStatus === 'loading') {
		return <PageLoader />;
	}

	return (
		<ApplicationsStoreContextProvider value={Store}>
			<MainLayout>
				<ContentLayout>
					<ApplicationsLayout
						mode='new'
						title={t('application.create')}
						selectionId={selectionId}
					/>
				</ContentLayout>
			</MainLayout>
		</ApplicationsStoreContextProvider>
	);
};

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { selectionId, themeId } = context.query;

	if (!!selectionId || !!themeId) {
		return {
			props: {
				selectionId: selectionId || themeId,
			},
		};
	}

	return {
		props: {},
		redirect: {
			permanent: false,
			destination: '/',
		},
	};
};

export default FormTemplatePage;
